import React from 'react';
import BuyManagerSelectorWrapper from './BuyManagerSelectorWrapper';
import ActiveUsersDisplay from './common/ActiveUsersDisplay';
import styles from '../styles.module.css';
import SwarmsSortDropDown from './SwarmsSortDropDown';
import SwarmsMetricsDisplay from './SwarmsMetricsDisplay';

export const TopBar = () => (
  <div className={styles.TopBar}>
    <div className={styles.TopBarLeft}>
      <SwarmsMetricsDisplay />
    </div>
    <div className={styles.TopBarRight}>
      <BuyManagerSelectorWrapper />
      <SwarmsSortDropDown />
      <ActiveUsersDisplay />
    </div>
  </div>
);
